export default "__VITE_ASSET__D28APCwV__"